import { render } from "./ProductBoxSegmentReview.vue?vue&type=template&id=27f090bd&ts=true"
import script from "./ProductBoxSegmentReview.vue?vue&type=script&lang=ts"
export * from "./ProductBoxSegmentReview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__